export default __webpack_public_path__ + "static/media/VAGINAL-IRRITATION.185805b7.png";